import {CreationAttribute} from 'src/modules/event-create/typedefs';
import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';

export const attributesMapToSave = (addedAttributes: CreationAttribute[]) =>
    addedAttributes.map(({attributeId, itemsType, ...rest}) => {
        return {...rest, itemsType, possibleValues: rest.possibleValues} as AttributeChangeRequest;
    });
